(function () {
  'use strict';
  if (window.LANEWILD_CONTENT_READY) return;
  window.LANEWILD_CONTENT_READY = true;

  function updateComparison(root) {
    var selected = Array.from(root.querySelectorAll('[data-compare-toggle]:checked')).map(function (input) { return input.value; });
    var onlyDifferences = root.querySelector('[data-compare-differences]').checked;
    root.querySelectorAll('[data-compare-column]').forEach(function (cell) {
      cell.hidden = selected.indexOf(cell.dataset.compareColumn) === -1;
    });
    var visibleRows = 0;
    root.querySelectorAll('[data-compare-row]').forEach(function (row) {
      var values = Array.from(row.querySelectorAll('[data-compare-value]')).filter(function (cell) { return !cell.hidden; }).map(function (cell) { return cell.textContent.replace(/\s+/g, ' ').trim(); });
      row.hidden = onlyDifferences && values.length > 1 && new Set(values).size === 1;
      if (!row.hidden) visibleRows += 1;
    });
    root.querySelector('[data-compare-table]').hidden = selected.length === 0;
    root.querySelector('[data-compare-empty]').hidden = selected.length !== 0;
    var message = selected.length + ' bike' + (selected.length === 1 ? '' : 's') + ' selected.';
    if (onlyDifferences && selected.length === 2) {
      message += visibleRows ? ' Showing ' + visibleRows + ' differing detail' + (visibleRows === 1 ? '.' : 's.') : ' No differences in the currently published details. Unknown specifications are not treated as verified matches.';
    }
    root.querySelector('[data-compare-status]').textContent = message;
    var count = root.querySelector('[data-compare-count]');
    if (count) count.textContent = selected.length + ' of 2 bikes selected';
    var mode = root.querySelector('[data-compare-mode]');
    if (mode) mode.textContent = onlyDifferences ? 'Differences' : 'Concept overview';
  }

  function direction(answers) {
    if (['city', 'weekend', 'mixed'].indexOf(answers.use) < 0 || ['step', 'either'].indexOf(answers.mount) < 0 || ['flat', 'drop', 'either'].indexOf(answers.bar) < 0) return null;
    if (answers.mount === 'step' && answers.bar === 'drop') return { key: 'conflict' };
    if (answers.mount === 'step' || answers.bar === 'flat') return { key: 'city', reason: answers.mount === 'step' ? 'You prefer a low step-through frame. Our city direction is a useful place to start.' : 'You prefer a familiar flat-bar position. Our city direction is a useful place to start.' };
    if (answers.bar === 'drop' || answers.use === 'weekend') return { key: 'gravel', reason: answers.bar === 'drop' ? 'You prefer a drop bar. Our gravel direction is a useful place to start.' : 'Weekend exploration is your starting point. Take a closer look at our gravel direction.' };
    if (answers.use === 'city') return { key: 'city', reason: 'Your main use is everyday city riding. With no stronger frame or bar preference, our city direction is a useful starting point.' };
    return { key: 'compare' };
  }

  function initialize(scope) {
    var comparisons = Array.from(scope.querySelectorAll('[data-bike-comparison]'));
    if (scope.matches && scope.matches('[data-bike-comparison]')) comparisons.push(scope);
    comparisons.forEach(function (root) {
      if (root.dataset.contentReady) return;
      root.dataset.contentReady = 'true';
      root.querySelectorAll('[data-compare-toggle], [data-compare-differences]').forEach(function (input) { input.disabled = false; });
      updateComparison(root);
    });
    scope.querySelectorAll('[data-finder-submit]').forEach(function (button) { button.disabled = false; });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-compare-toggle], [data-compare-differences]')) return;
    var root = event.target.closest('[data-bike-comparison]');
    if (root) updateComparison(root);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-finder-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    var root = form.closest('[data-ride-finder]');
    var values = new FormData(form);
    var result = direction({ use: values.get('use'), mount: values.get('mount'), bar: values.get('bar') });
    if (!result) return;
    var template = root.querySelector('[data-finder-template="' + result.key + '"]');
    if (!template) return;
    var output = root.querySelector('[data-finder-result]');
    output.replaceChildren(template.content.cloneNode(true));
    var reason = output.querySelector('[data-finder-reason]');
    if (reason) reason.textContent = result.reason;
    output.hidden = false;
    output.focus({ preventScroll: true });
    output.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-finder-reset]');
    if (!button) return;
    var root = button.closest('[data-ride-finder]');
    var form = root.querySelector('[data-finder-form]');
    form.reset();
    var output = root.querySelector('[data-finder-result]');
    output.hidden = true;
    output.replaceChildren();
    form.querySelector('input').focus();
  });

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
})();
